// Why an open sales order line is not on a live picking list - the Pick Status column on Sales
// Order Line Item (4Spaces stuck orders, Oct 2026). Mirrors TMSWeb.Common.Constants.PickStatuses:
// the API sends a CODE, because its Search response is not translated server-side, and the label
// is worded here in $localize. The two lists must stay in step.
export enum PickStatuses {
  customerOnStop = 'CustomerOnStop',
  proformaNotPaid = 'ProformaNotPaid',
  creditNotPassed = 'CreditNotPassed',
  lineReserved = 'LineReserved',
  orderOnHold = 'OrderOnHold',
  lineHeld = 'LineHeld',
  lineNotConfirmed = 'LineNotConfirmed',
  noDespatchWarehouse = 'NoDespatchWarehouse',
  noDespatchWarehouseWhenReady = 'NoDespatchWarehouseWhenReady',
  awaitingManufacture = 'AwaitingManufacture',
  atCutting = 'AtCutting',
  readyAtSource = 'ReadyAtSource',
  inTransfer = 'InTransfer',
  awaitingStock = 'AwaitingStock',
  availableToPick = 'AvailableToPick',
}

// The status as a person reads it.
export function pickStatusName(code: string | undefined | null): string {
  switch (code) {
    case PickStatuses.customerOnStop:
      return $localize`Customer on stop`;
    case PickStatuses.proformaNotPaid:
      return $localize`Proforma not paid`;
    case PickStatuses.creditNotPassed:
      return $localize`Credit not passed`;
    case PickStatuses.lineReserved:
      return $localize`Line reserved`;
    case PickStatuses.orderOnHold:
      return $localize`Order on hold`;
    case PickStatuses.lineHeld:
      return $localize`Line held`;
    case PickStatuses.lineNotConfirmed:
      return $localize`Line not confirmed`;
    case PickStatuses.noDespatchWarehouse:
      return $localize`No despatch warehouse`;
    case PickStatuses.noDespatchWarehouseWhenReady:
      return $localize`No despatch warehouse (when ready)`;
    case PickStatuses.awaitingManufacture:
      return $localize`Awaiting manufacture`;
    case PickStatuses.atCutting:
      return $localize`At cutting`;
    case PickStatuses.readyAtSource:
      return $localize`Ready at source (transfer)`;
    case PickStatuses.inTransfer:
      return $localize`In transfer`;
    case PickStatuses.awaitingStock:
      return $localize`Awaiting stock`;
    case PickStatuses.availableToPick:
      return $localize`Available to pick`;
    default:
      // Anything unrecognised shows as sent rather than vanishing.
      return code ?? '';
  }
}

// Grid column options for a pick status field - spread into gridService.text. A valueGetter, not a
// formatter, so the filter and the CSV export use the translated text too (see fulfilment-routes.ts).
export function pickStatusColumnOptions(field = 'pickStatus') {
  return { valueGetter: (params: { data?: Record<string, string> }) => pickStatusName(params.data?.[field]) };
}
